<footer class="footer">
  <div class="footer-content">
    <!-- Primary compact bar -->
    <div class="footer-bar">
      <div class="footer-bar__brand">
        <i class="fas fa-leaf footer-bar__leaf"></i>
        <span class="footer-bar__name">ESG Integral</span>
      </div>

      <span class="footer-bar__dot" aria-hidden="true"></span>

      <nav class="footer-bar__nav" aria-label="Footer navigation">
        <a routerLink="/risk">Greenwashing Risk</a>
        <a routerLink="/company-summary">Company Analysis</a>
        <a routerLink="/similar-companies">Similar Companies</a>
        <a routerLink="/eda">Data Insights</a>
        <a routerLink="/text-analysis">Text Analysis</a>
        <a routerLink="/prediction">Prediction</a>
        <!-- <a routerLink="/finance">Finance</a> -->
        <a routerLink="/about">About</a>
        <a routerLink="/help">Help</a>
      </nav>

      <span class="footer-bar__dot" aria-hidden="true"></span>

    </div>

    <!-- Logos row -->
    <!-- <div class="footer-meta">
      <div class="footer-meta__about">
        <div class="footer-meta__logos">
          <img src="assets/images/UKFin+ Logo_1.png" alt="UKFin+" class="footer-logo">
          <img src="assets/images/UKRI.png" alt="UKRI" class="footer-logo">
          <img src="assets/images/UEL.png" alt="UEL" class="footer-logo">
          <img src="assets/images/Cykube.png" alt="Cykube" class="footer-logo">
          <img src="assets/images/GDF.png" alt="GDF" class="footer-logo">
        </div>
      </div>
    </div> -->

    <!-- Contact — single centered line -->
    <!-- <div class="footer-contact-bar">
      <strong>Dr. Fahimeh Jafari</strong>
      <span class="footer-bar__dot" aria-hidden="true"></span>
      <span class="footer-contact-bar__role">Principal Investigator</span>
      <span class="footer-bar__dot" aria-hidden="true"></span>
      <a href="mailto:F.Jafari@uel.ac.uk" class="footer-contact-bar__email">F.Jafari@uel.ac.uk</a>
      <span class="footer-bar__dot" aria-hidden="true"></span>
      <span>Greenwashing Analysis Pilot Project</span>
      <span class="footer-bar__dot" aria-hidden="true"></span>
      <span>University of East London</span>
    </div> -->


    <p class="footer-copyright">
      © 2025 UKFin+ Greenwashing Analysis Pilot. All rights reserved.
    </p>
  </div>
</footer> 